import { render, staticRenderFns } from "./license_status_icon.vue?vue&type=template&id=6e966b51&"
import script from "./license_status_icon.vue?vue&type=script&lang=js&"
export * from "./license_status_icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports